export const environment = {
  production: true,
  pagination: {
    size: 20,
    options: [20, 50, 100]
  }
};
